import initialStore from './initialState'
import { EmployeesAction } from './actionNames'

export default function(
  store: Readonly<IEmployeesStore> = initialStore,
  action: any,
): IEmployeesStore {
  switch (action.type) {
    case EmployeesAction.SetEmailError:
      return {
        ...store,
        emailError: action.payload,
      }
    case EmployeesAction.SetTab:
      return {
        ...store,
        tab: action.payload,
        editEmployee: null,
      }
    case EmployeesAction.AddOrUpdateEmployee:
      return {
        ...store,
        loading: true,
      }
    case EmployeesAction.SetEmployeeLoading:
      return {
        ...store,
        loading: action.payload,
      }
    case EmployeesAction.SetEmployees:
      return {
        ...store,
        employees: action.payload,
        editEmployee: null,
        loading: false,
      }
    case EmployeesAction.EditEmployee:
      return {
        ...store,
        tab: 1,
        editEmployee: store.employees.find(e => e.id === action.payload),
      }
  }

  return store
}

export interface IEmployeesStore {
  employees: any[]
  emailError: string
  loading: boolean
  tab: number
  editEmployee: any
}
